import { Component, ComponentInterface, Element, h, Host, JSX, Listen } from '@stencil/core';
import { transformTagNames } from '../../../global/transform-tag-name';
import { querySelectorAllAsArray } from '../../../utils/query-selector-all-as-array';
import { DropdownItemSelectionChangeDetail } from '../dropdown.types';

/**
 * @slot - wb-dropdown-list-items has to be slotted here (required)
 */
@Component({
  tag: 'wb-dropdown-list',
  shadow: true,
})
export class DropdownListComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  private TagNames = transformTagNames(this, 'wb-dropdown-list', ['wb-dropdown-list-item', 'wb-list-group']);

  private listItemElements: Array<HTMLWbDropdownListItemElement> = [];

  @Listen('wbdropdownlistitemselectionchange')
  public onDropdownListItemSelectionChange(event: CustomEvent<DropdownItemSelectionChangeDetail>): void {
    this.listItemElements.forEach((element, index) => {
      element.selected = index === event.detail.index;
    });
  }

  private setListItemElements(): void {
    this.listItemElements = querySelectorAllAsArray(this.el, this.TagNames.WbDropdownListItem);
  }

  private onSlotChange = (): void => {
    this.setListItemElements();
  };

  public render(): JSX.Element {
    const { WbListGroup } = this.TagNames;

    return (
      <Host class="wb-dropdown-list">
        <WbListGroup class="selection-items-wrapper" hide-border>
          <slot onSlotchange={this.onSlotChange} />
        </WbListGroup>
      </Host>
    );
  }
}
